<template>
  <div class="row">
    <div class="col-12">
      <p class="lead">Análise de Risco</p>
    </div>
  </div>
  <div class="row mb-3 no-print">
    <div class="col-12">
      <router-link
        to="preliminary-risk-analyses"
        class="btn btn-success"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
        Voltar para AR
      </router-link>

      <a 
        v-if="confinedSpaceId && authenticated_user !== 'Cliente somente leitura'" 
        @click="goToNewBV" 
        class="btn btn-success ml-2"
      >
        Adicionar B.V.
      </a>

      <button
        @click="print"
        class="btn btn-primary ml-2"
      >
        <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
        Salvar / Imprimir
      </button>
    </div>
  </div>

  <div class="row mb-3" v-if="risks?.length > 0">
    <div class="col-12 d-flex">
      <label class="mr-2">
        {{ risks?.length == 1 ? 'Categoria de risco selecionada' : 'Categorias de risco selecionadas' }}:
      </label>
      <div v-for="risk in risks" :key="risk" class="mr-2">
        <div
          class="risk-category"
          :style="`background-color: ${getRiskColor(risk)}`"
        >
          {{ getRiskCategoryLabel(risk) }}
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3" v-if="confined_space">
    <div class="col-12">
      <confined-space-header
        :confined-space="confined_space"
        :max-fine="max_fine"
        :prepare-for-print="loadingPrint"
      ></confined-space-header>
    </div>
  </div>

  <div class="row confined-space-aprs mt-3">
    <div class="col-12">
      <confined-space-table
        :confined-space-aprs="confined_space_aprs"
      ></confined-space-table>
    </div>
  </div>
</template>

<script>
  import ConfinedSpaceHeader from './components/ConfinedSpaceHeader.vue'
  import ConfinedSpaceTable from './components/ConfinedSpaceTable.vue'
  import { useStore } from 'vuex'
  import { computed } from '@vue/runtime-core'
  import { useRoute, useRouter } from 'vue-router'
  import useDegreeOfRisk from '@/modules/DegreeOfRiskUtil.js'

  export default {
    setup() {
      const route = useRoute()
      const router = useRouter()
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

      const risks = route?.params?.risks?.map(risk => parseInt(risk))

      const { getRiskColor } = useDegreeOfRisk()

      const adequacy_status = [
        { label: 'Conforme', value: 0 },
        { label: 'Muito Baixo', value: 1 },
        { label: 'Baixo', value: 2 },
        { label: 'Médio', value: 3 },
        { label: 'Alto', value: 4 },
        { label: 'Muito Alto', value: 5 }
      ]

      return {
        selected_company,
        confinedSpaceId: route?.params?.confinedSpaceId,
        router,
        authenticated_user,
        risks,
        getRiskColor,
        adequacy_status
      }
    },
    components: {
      ConfinedSpaceHeader,
      ConfinedSpaceTable,
    },
    data() {
      return {
        confined_space: null,
        confined_space_aprs: [],
        max_fine: 0,
        loading: false,
        loadingPrint: false,
      }
    },
    mounted() {
      this.get()
      this.listRiskAnalysis()
    },
    methods: {
      get() {
        const app = this

        app.axios
          .get(`/api/confined_spaces/get/${this.confinedSpaceId}`)
          .then(({data}) => {
            app.confined_space = data.data
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            app.loading = false
          })
      },
      async listRiskAnalysis() {
        const app = this
        const confinedSpaceId = this.$route.params.confinedSpaceId

        let aprs = await app.axios
          .get(`/api/confined-spaces/${confinedSpaceId}/risk-analysis/all`)
          .then(response => {
            const confined_space_aprs = response.data.data
            let fines = Object.values(confined_space_aprs).map(apr => Object.assign({}, apr).max_fine_value)
            fines = fines.map(fine => parseFloat(fine.slice(0, -3).replace('.', '')))
            app.max_fine = fines.reduce((a, b) => a + b)
            return confined_space_aprs
          })
          .catch(error => {
            console.log(error)
            return []
          })

        if (this.risks?.length > 0) {
          aprs = aprs.filter(apr => this.risks.includes(apr.calculated_hrn_level))
        }

        app.confined_space_aprs = aprs
      },
      goToNewBV() {
        this.router.push({
          name: 'confined-spaces-risk-analyses-create',
          params: { confinedSpaceId: this.confinedSpaceId },
        })
      },
      print() {
        if (this.loadingPrint) return

        this.loadingPrint = true

        Promise.all(
          Array.from(document.images)
            .filter((img) => !img.complete)
            .map(
              (img) =>
                new Promise((resolve) => {
                  img.onload = img.onerror = resolve
                }),
            ),
        ).then(() => {
          console.log('images finished loading')
          this.loadingPrint = false
          window.print()
        })
      },
      getRiskCategoryLabel(risk) {
        return this.adequacy_status.filter(status => status.value == risk)[0].label
      },
    },
  }
</script>
